// =============================================================================
// components/ux/NightLightProvider.tsx
// Injects CSS variables into :root and manages global Night Light state.
// =============================================================================

import { useEffect, type JSX } from 'react';
import { useNightLightStore, applyNightLightVars } from '../../stores/nightLight.store.js';

export function NightLightProvider(): null {
  const store = useNightLightStore();
  const {
    enabled, brightness, glow, contrast, laserIntensity,
    navBrightness, workspaceBrightness, controlBrightness,
    bgOpacity, decoOpacity, minTextContrast, emergencyAlwaysFull,
  } = store;

  useEffect(() => {
    applyNightLightVars(
      { brightness, glow, contrast, laserIntensity, navBrightness, workspaceBrightness, controlBrightness, bgOpacity, decoOpacity, minTextContrast, emergencyAlwaysFull },
      enabled,
    );
  }, [enabled, brightness, glow, contrast, laserIntensity, navBrightness, workspaceBrightness, controlBrightness, bgOpacity, decoOpacity, minTextContrast, emergencyAlwaysFull]);

  return null;
}
